import { NavLink, useLocation } from 'react-router-dom';

import {
  IconChevronDown as ChevronDownSVG,
  IconChevronUp as ChevronUpSVG,
  IconGetStarted as GetStartedSVG,
} from '../../../core';
import { Menus, NavigationTab } from '../types';

import CompactTab from './CompactTab';

const GetStarted = ({
  handleMenuCollapse,
  collapsedMenus,
  isMenuClosed,
  setIsMenuClosed,
}: Omit<NavigationTab, 'collapsedSubMenus'>) => {
  const location = useLocation();
  const link = '/';

  if (isMenuClosed)
    return (
      <CompactTab
        menuOption={Menus.GET_STARTED}
        icon={<GetStartedSVG />}
        handleMenuCollapse={handleMenuCollapse}
        setIsMenuClosed={setIsMenuClosed}
        href={link}
      />
    );

  return (
    <li>
      <NavLink
        to={link}
        onClick={() => handleMenuCollapse(Menus.GET_STARTED)}
        className={location.pathname.startsWith('/get-started') ? 'active' : ''}
      >
        <>
          <div>
            <GetStartedSVG />
            <span>Get Started</span>
          </div>
          {collapsedMenus.includes(Menus.GET_STARTED) ? <ChevronDownSVG /> : <ChevronUpSVG />}
        </>
      </NavLink>
      <ul className={`lvl-2 ${collapsedMenus.includes(Menus.GET_STARTED) ? 'collapsed' : ''}`}>
        <li>
          <NavLink
            to="/get-started/accessibility"
            className={({ isActive }) => (isActive ? 'active' : '')}
          >
            <span>Accessibility</span>
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/get-started/content"
            className={({ isActive }) => (isActive ? 'active' : '')}
          >
            <span>Content</span>
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/get-started/voice-and-tone"
            className={({ isActive }) => (isActive ? 'active' : '')}
          >
            <span>Voice & Tone</span>
          </NavLink>
        </li>
      </ul>
    </li>
  );
};

export default GetStarted;
